import { __decorate } from "tslib";
import { ActivityEventType } from '@metaos/mfs-telemetry';
import { mfsErrorHandler } from '../errors/mfsErrorHandler';
import { toCard } from '../utility/cardUtils';
import { MFS_CARD_TYPE, VIEW_RETRIEVAL_MAX_DEPTH } from '../utility/constant/constants';
import { logActivity } from '../utility/telemetry';
import { getMfsItem } from '../utility/utils';
import { getDefaultCompareFunc, orderByIdentifier } from '../utility/viewUtils';
/** Concrete implementation for Full View retriever. */
export class FullView {
    constructor(dataStore) {
        this.dataStore = dataStore;
    }
    /**
     * Gets list of cards ordered by the card's latest updatedAt timestamp.
     *
     * Full view is a projection of cards based on the card's latest updatedAt time, and returns a flat list of `CardRecord` containing
     * the `Card` and `updatedAt` timestamp.
     * By default, cards are ordered in reverse chronological order with most recent updated card listed at the beginning.
     *
     * @param criteria The user specified criteria used for searching and querying
     * @returns An IterableIterator of `Card`
     * @throws When the cardId within the criteria is invalid or when an unexpected error happens while querying.
     */
    retrieve(criteria) {
        const rootCard = getMfsItem(this.dataStore, criteria.cardId, MFS_CARD_TYPE);
        if (!rootCard)
            return [].values();
        try {
            const results = [];
            const queue = [];
            const resultCardIds = new Set();
            queue.push([rootCard, 0]);
            resultCardIds.add(rootCard.id);
            while (queue.length > 0) {
                const cardTuple = queue.shift();
                if (!cardTuple)
                    continue;
                const [currCard, depth] = cardTuple;
                if (depth < VIEW_RETRIEVAL_MAX_DEPTH) {
                    for (const { item: childCard } of this.dataStore.getCollectionItems(currCard.id)) {
                        if (resultCardIds.has(childCard.id))
                            continue;
                        resultCardIds.add(childCard.id);
                        queue.push([childCard, depth + 1]);
                    }
                }
                const card = toCard(this.dataStore, currCard);
                if (!criteria.query || !criteria.query.filter || criteria.query.filter(card)) {
                    results.push(card);
                }
            }
            return orderByIdentifier(results, (arg) => { var _a; return ((_a = arg.updatedAt) !== null && _a !== void 0 ? _a : 0); }, getDefaultCompareFunc(criteria.order)).values();
        }
        catch (error) {
            throw mfsErrorHandler(`An unexpected error has happened, please try again.`, error);
        }
    }
}
__decorate([
    logActivity(ActivityEventType.SINGLE, undefined, 'viewByFull')
], FullView.prototype, "retrieve", null);
//# sourceMappingURL=fullView.js.map